<a href="#main-content" class="govuk-skip-link" data-module="govuk-skip-link" (click)="skipToMainContent($event)">Skip
  to main content</a>
<ui-timeout></ui-timeout>
<app-header></app-header>

<!-- <app-skip-to-content></app-skip-to-content> -->


<alert role="alert" aria-live="polite"></alert>
<ngx-spinner role="status" bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-beat" [fullScreen]="true">
  <p style="color: white"> Processing... Please Wait </p>
  <div role="status" aria-live="polite" class="visually-hidden">
    Loading, please wait...
  </div>
</ngx-spinner>
<div class="flex-grow-1">
  <router-outlet></router-outlet>
</div>

<app-footer></app-footer>